import { type ReactNode } from 'react'
import { cn } from '~/utils/misc.tsx'

export const MainContainer = ({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <main
      className={cn(
        'relative mx-auto w-full max-w-[1540px] px-3 pt-2 sm:px-8',
        className,
      )}
    >
      {children}
    </main>
  )
}
